module.exports = __webpack_public_path__ + "img/agent.a165e21c.png";